export default __webpack_public_path__ + "static/media/AI1 v2.b85d52fb.png";